import styled from "styled-components/macro";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;

  padding-top: 7em;
  margin-left: auto;
  margin-right: auto;
  width: 75%;
  color: var(--grey-0);

  font-family: Inter;

  .home-instructions {
    display: flex;
    flex-direction: column;

    text-align: center;
    max-width: 700px;
    margin: 0 auto;

    .title {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 2em;
      font-family: "GT Super Text";

      svg {
        width: 50px;
        margin-right: 10px;
      }
    }

    p {
      font-family: Inter;
      font-weight: 600;
      line-height: 1em !important;
    }

    .description-line-height {
      line-height: 1.4 !important;
    }

    .important-notes {
      .notes-header {
        margin-bottom: 1em;
      }

      .notes-list {
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: left;
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;

        li {
          position: relative;
          padding-left: 1.5em;
          margin-bottom: 0.75em;

          &::before {
            content: "•";
            color: var(--primary-cta);
            font-size: 1.2em;
            font-weight: bold;
            position: absolute;
            left: 0;
            top: 0;
          }

          .note-item {
            line-height: 1.4;
            display: block;
          }
        }
      }
    }
  }

  .home-inputs {
    display: flex;
    gap: 2em;
    align-items: stretch;
    max-width: 1200px;
    margin: 0 auto;

    > * {
      flex: 1;
      height: 400px; /* Square dimensions */
      aspect-ratio: 1;
    }

    .upload {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      color: var(--grey-0);
      border-radius: 20px;

      border: 1.5px dashed var(--grey-1);
      transition: background 200ms ease-in-out, transform 200ms ease-in-out;

      &.rejected {
        border-color: var(--grey-2);
      }

      &.accepted {
        border-color: var(--grey-0);
        background: var(--primary-cta-transparent);
        transform: scale(1.03);
      }

      &.complete {
        border-style: solid;
        background: var(--primary-cta-transparent);
        svg {
          path {
            fill: var(--grey-0) !important;
            stroke: none;
          }
        }
      }

      svg {
        margin-bottom: 1em;
        path {
          stroke: var(--grey-0);
        }
      }

      .title {
        font-weight: 500;
        font-size: 1.1em;
        color: var(--grey-0);
      }

      .supported-format {
        color: var(--grey-1);
      }

      .upload-link {
        margin-top: 1em;
      }
    }

    .textarea-container {
      display: flex;
      flex-direction: column;
      min-height: 404px;
      width: 400px;

      textarea {
        flex: 1;
        width: 100%;
        height: 100%;
        padding: 2em;
        border-radius: 20px;
        border: 1.5px dashed var(--grey-1);
        background: transparent;
        color: var(--grey-0);
        font-family: Inter;
        font-size: 1em;
        line-height: 1.4;
        resize: none;
        outline: none;
        transition: border-color 200ms ease-in-out, background 200ms ease-in-out;
        box-sizing: border-box;

        &::placeholder {
          color: var(--grey-1);
          font-size: 1.1em;
          font-weight: 500;
        }

        &:focus {
          border-color: var(--primary-cta);
          background: var(--primary-cta-transparent);
        }

        &:not(:placeholder-shown) {
          border-style: solid;
          background: var(--primary-cta-transparent);
        }
      }
    }
  }

  .home-actions {
    display: flex;
    justify-content: flex-end;

    button {
      /* Existing button styles will be inherited */
    }
  }
`;

export const TrainingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 95vh;
  box-shadow: var(--light-drop-shadow);

  .training-container-inner {
    background-color: var(--document-background);
    padding: 2em;
    border-radius: 20px;
    min-width: 600px;
  }

  .title {
    color: var(--primary-cta-high-contrast);
    font-weight: 600;
    font-size: 1.3em;
    margin-top: 1em;
  }

  svg {
    path {
      fill: var(--grey-0) !important;
    }
  }

  .loading-bar {
    width: 50%;
    background-color: var(--primary-cta-transparent);
    border-radius: 20px;
    height: 12px;
    padding: 4px;
    margin-top: 0.5em;

    .bar {
      border-radius: 20px;
      height: 100%;
      transition: width 0.5s;
      background-color: var(--primary-cta);
    }
  }

  .remaining-time {
    color: var(--grey-0);
    margin-top: 0.75em;
    font-size: 1.2em;
    font-weight: 500;
  }

  .info {
    margin-top: 2em;
    font-size: 1.1em;
    color: var(--grey-1);
  }

  button {
    margin-top: 2em !important;
  }

  .training-checklist {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    width: 100%;
    max-width: 300px;
    margin: 2em auto;
    border-radius: 12px;
    padding: 1em;
    max-height: 250px;
    overflow: scroll;

    .checklist-item {
      display: flex;
      align-items: center;
      gap: 1em;
      padding: 0.5em 0.75em;
      border-radius: 8px;
      border: 1px solid var(--grey-3);
      transition: all 300ms ease-in-out;
      opacity: 0;
      transform: translateY(10px);
      animation: slideIn 300ms ease-out forwards;

      .status-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5em;
        height: 1.5em;

        svg {
          width: 1.2em;
          height: 1.2em;

          &.spinning {
            animation: spin 1s linear infinite;
          }

          path {
            fill: #51cf27 !important;
          }
        }
      }

      .item-text {
        color: var(--grey-0);
        font-weight: 500;
        font-size: 1em;
      }
    }
  }

  .progress-info {
    margin-top: 1.5em;

    p {
      color: var(--grey-1);
      font-size: 1em;
      text-align: center;
    }
  }

  .video-container {
    display: flex;
    justify-content: center;
    margin: 2em 0;

    .video-thumbnail-link {
      position: relative;
      display: inline-block;
      cursor: pointer;
      transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: var(--light-drop-shadow);

      &:hover {
        transform: scale(1.02);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      }

      img {
        display: block;
        width: 560px;
        height: 315px;
        object-fit: cover;
        border-radius: 12px;
      }

      // Play button overlay
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90px;
        height: 90px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 50%;
        opacity: 0.8;
        transition: opacity 0.2s ease-in-out;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M8 5v14l11-7z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: 52% center;
        background-size: 96px 96px;
      }
    }
  }

  @keyframes slideIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 95vh;

  p {
    font-weight: 500;
    font-size: 1.2em;
    color: var(--grey-1);
  }
`;

export const StyleSamplesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4em 6em;
  max-width: 800px;
  margin: 0 auto;
  height: 90vh;
  color: var(--grey-0);
  font-family: Inter;

  .header {
    text-align: center;
    margin-bottom: 3em;

    h1 {
      font-size: 2em;
      font-weight: 600;
      margin: 0;
      color: var(--grey-0);
      font-family: "GT Super Text";
      text-align: center;
    }
  }

  .samples-list {
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin-bottom: 3em;

    .empty-state {
      text-align: center;
      color: var(--grey-1);
      font-size: 1.1em;
    }
  }

  .style-sample-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5em 1.25em;
    background: var(--document-background);
    border-radius: 12px;
    box-shadow: var(--light-drop-shadow);
    transition: background 200ms ease-in-out, border-color 200ms ease-in-out;

    .sample-name {
      font-size: 1.1em;
      font-weight: 600;
      color: var(--grey-0);
      flex: 1;
      text-align: left;
      padding: 0.5em 0.75em;
    }

    .menu-container {
      position: relative;
    }

    .hotdog-menu {
      background: transparent !important;
      border: none;
      padding: 0.5em !important;
      cursor: pointer;
      border-radius: 4px;
      margin-top: 0 !important;
      transition: color 200ms ease-in-out, background 200ms ease-in-out;

      &:hover {
        color: var(--grey-0);
        background: rgba(255, 255, 255, 0.1);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      svg {
        display: block;
        circle {
          fill: var(--grey-0) !important;
        }
      }
    }

    .flyout-menu {
      position: absolute;
      top: 100%;
      right: 0;
      border-radius: 8px;
      padding: 10px;
      min-width: 120px;
      z-index: 1000;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      display: flex;
      gap: 0.5em;
      background-color: var(--document-background);

      .flyout-item {
        display: block;
        width: 100%;
        background: transparent;
        border: none;
        padding: 0.75em 1em;
        text-align: left;
        color: var(--grey-0);
        font-family: Inter;
        font-size: 0.9em;
        cursor: pointer;
        transition: background 200ms ease-in-out;
        padding: 10px;
        white-space: nowrap;
        margin-top: 0 !important;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        &.delete {
          color: #ff6b6b;

          &:hover {
            background: rgba(255, 107, 107, 0.1);
          }
        }
      }
    }

    .editable-name {
      flex: 1;
      max-width: 50%;

      input {
        width: 100%;
        background: transparent;
        border: 1px solid var(--primary-cta);
        border-radius: 6px;
        padding: 0.5em 0.75em;
        color: var(--grey-0);
        font-family: Inter;
        font-size: 1.1em;
        font-weight: 500;
        outline: none;

        &:focus {
          box-shadow: 0 0 0 2px var(--primary-cta-transparent);
        }

        &:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      }
    }
  }

  .actions {
    display: flex;
    justify-content: center;

    .train-new-button {
      background: var(--primary-cta);
      border: none;
      border-radius: 12px;
      padding: 1em 2.5em;
      color: white;
      font-family: Inter;
      font-size: 1.1em;
      font-weight: 600;
      cursor: pointer;
      transition: background 200ms ease-in-out, transform 100ms ease-in-out;

      &:hover {
        background: var(--primary-cta-high-contrast);
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .description {
    font-size: 1.1em;
    color: var(--grey-1);
    margin-top: 2em;
  }

  .description-highlight {
    color: var(--grey-0);
    font-weight: 600;
  }
`;
